import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M12 17.25a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      d: "M12 13.5V6"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.28 13.281a1.81 1.81 0 0 1 0-2.561l9.44-9.439a1.81 1.81 0 0 1 2.56 0l9.44 9.439a1.81 1.81 0 0 1 0 2.561l-9.44 9.439a1.81 1.81 0 0 1-2.56 0z"
    }, null, -1)
  ]));
}
const interfaceAlertExclamationDiamond = { render };
export {
  interfaceAlertExclamationDiamond as default,
  render
};
//# sourceMappingURL=interface-alert-exclamation-diamond.svg.js.map
